
import {changeContract} from "./contractSlice";

import {Avatar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip} from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import * as React from "react";
import {
    copyContract, deleteSingleContract,
    generateContractFromAbstract, generateContractFromMasterContract, getBlockingPartsDeal, getContractProduct,
    getGeneratedAbstractCount, moveContract
} from "./ContractClient";
import {changeContractStats} from "../WorkQueue/WorkStats/contractStatsSlice";
import {changeWorkQueue} from "../WorkQueue/workQueueSlice";
import {changeWork} from "../Work/workSlice";
import {changeContractSearch} from "../WorkQueue/Contracts/contractSearchSlice";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import Menu from "@mui/material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";


export default function ContractGridMenu({dispatchData, selectorContractId2, selectorContractAPI, setSubmitting,
                                             currentUserId,
                                             currentUserName,
                                             currentUserDepartment, handleEdit, selectorContractGridAPI,
                                             selectorContractId}) {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const isMenuOpen = Boolean(anchorEl);

    const handleCrudMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };


    function handleMenuClose()  {
        setAnchorEl(null);

    };

    const handleMoveUp = () => {
        setAnchorEl(null);
        console.log("move contract up");
        console.log("selectorContractId = ", selectorContractId);
        console.log("selectorContractId2 = ", selectorContractId2);
        console.log("selectorContractAPI = ", selectorContractAPI);
        moveContract(selectorContractId2,'Up', selectorContractAPI).
        then(() => {
            dispatchData(changeContract({
                cGridRefresh: true
            }));
        })
    };

    const handleMoveDown = () => {
        setAnchorEl(null);
        console.log("move contract down");
        console.log("selectorContractId = ", selectorContractId);
        console.log("selectorContractId2 = ", selectorContractId2);
        console.log("selectorContractAPI = ", selectorContractAPI);
        // moveContract(selectorContractId2,'Down', selectorContractAPI).
        moveContract(selectorContractId2,'Down', selectorContractAPI).
        then(() => {
            dispatchData(changeContract({
                cGridRefresh: true
            }));
        })
    };



    const handleAbstract = () => {
        setSubmitting(true);
        setAnchorEl(null);
        console.log("a new abstract will get created from this standard contract: ", selectorContractId2)   ;
        copyContract(selectorContractId2,'Abstract'
        ).then(() => {
                setSubmitting(false);
                setTimeout(() => {
                    if(selectorContractGridAPI === "PartsStandards") {console.log("selectorContractGridAPI = PartsStandards")
                    dispatchData(changeContract({
                        participationsTabsIndex: 1,
                        contractGridAPI: "PartsAbstracts",
                        contractDrawerState: false,
                        contractDrawerMode: null
                        ,residualsTabsVisible: false
                        ,contractGridVisible: true
                        ,contractDrilldownVisible: false
                        ,contractSearchVisible: false
                        ,contractConfigVisible: false
                        ,contractView: null
                        ,participationsTabsVisible: true
                        ,royaltiesTabsVisible: false
                        ,cGridRefresh: true
                    }));}
                    if(selectorContractGridAPI === "RoyalStandards") {console.log("selectorContractGridAPI = RoyalStandards")
                        dispatchData(changeContract({
                            royaltiesTabsIndex: 1,
                            contractGridAPI: "RoyalAbstracts",
                            contractDrawerState: false,
                            contractDrawerMode: null
                            ,residualsTabsVisible: false
                            ,contractGridVisible: true
                            ,contractDrilldownVisible: false
                            ,contractSearchVisible: false
                            ,contractConfigVisible: false
                            ,contractView: null
                            ,participationsTabsVisible: false
                            ,royaltiesTabsVisible: true
                            ,cGridRefresh: true
                        }));}
                }, 1000); // 1 second delay

            }
        );
    };


    const handlePartsStandard = () => {
        setSubmitting(true);

        setAnchorEl(null);
        console.log("a new standard contract will get created from this abstract: ", selectorContractId2)   ;
        copyContract(selectorContractId2,'Standard Contract'
        ).then(() => {

                dispatchData(changeContract({
                    contractDrawerState: false,
                    contractDrawerMode: null
                    ,residualsTabsVisible: false
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: true
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: true
                }));
                setSubmitting(false);

            }
        );
    };


    const handleClone = () => {
        setSubmitting(true);

        setAnchorEl(null);
        console.log("this template will get cloned: ", selectorContractId2)   ;
        copyContract(selectorContractId2,'NA'
        ).then(() => {

                dispatchData(changeContract({
                    contractDrawerState: false,
                    contractDrawerMode: null
                    ,residualsTabsVisible: true
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: false
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: true
                }));
                setSubmitting(false);
            }
        );
    };

    const handleSideletterFromTemplate = () => {
        setSubmitting(true);
        setAnchorEl(null);
        console.log("this template will get cloned: ", selectorContractId2)   ;
        copyContract(selectorContractId2,'Sideletter'
        ).then(() => {

                dispatchData(changeContract({
                    contractDrawerState: false,
                    contractDrawerMode: null
                    ,residualsTabsVisible: true
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: false
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: true
                }));
                setSubmitting(false);

            }
        );

    };



    //
    // const handleGenerateContractFromAbstract = () => {
    //     setSubmitting(true);
    //     setAnchorEl(null);
    //
    //     console.log("this abstract will generate the new contract: ", selectorContractId2);
    //     console.log("currentUserId = ", currentUserId);
    //     console.log("currentUserName = ", currentUserName);
    //     console.log("currentUserDepartment = ", currentUserDepartment);
    //     getGeneratedAbstractCount(selectorContractId2)
    //         .then(res =>
    //         let blockingContracts = res;
    //         console.log("blocking contracts = ", blockingContracts)
    //     if (blockingContracts === 0) {
    //     // return generateContractFromAbstract(
    //     generateContractFromAbstract(
    //         selectorContractId2,
    //         currentUserId,
    //         currentUserName,
    //         currentUserId,
    //         currentUserDepartment
    //     ))
    //         // .then(({ data: genData }) => {
    //         //     const newContractId = genData?.[0]?.new_contract_id;
    //         //     console.log("new contract's id after generating = ", newContractId);
    //         //     if (!newContractId) throw new Error("No new_contract_id in response");
    //         //     return getContractProduct(newContractId);
    //         // })
    //         .then((res) => {
    //
    //             console.log("axios response:", res);         // full Axios response
    //             const data = res.data;                        // unwrap once here
    //             console.log("data:", data);                   // should be number or object
    //
    //
    //             let newContractId;
    //
    //             if (typeof data === 'number') {
    //                 dispatchData(changeContract({
    //                     contractIdGeneratedFromAbstract: data
    //                 }));
    //                 dispatchData(changeWorkQueue({
    //                     selectedContractId:  data,
    //                     selectedContractDisplayFolders: true}));
    //                 newContractId = data;
    //
    //             } else if (Array.isArray(data)) {
    //                 newContractId = data[0]?.new_contract_id;
    //             } else if (data && typeof data === 'object') {
    //                 newContractId = data.new_contract_id ?? data.id; // fallback if your controller returns {id: ...}
    //             }
    //
    //             // Coerce string -> number if needed
    //             if (typeof newContractId === 'string') {
    //                 const n = Number(newContractId);
    //                 newContractId = Number.isFinite(n) ? n : null;
    //             }
    //
    //             // Only treat null/undefined as missing (not 0)
    //             if (newContractId == null) {
    //                 console.error('Unexpected response shape:', data);
    //                 throw new Error('No new_contract_id in response');
    //             }
    //
    //             console.log("selectorContractIdGeneratedFromAbstract 1 ", selectorContractIdGeneratedFromAbstract);
    //             console.log('new contract id:', newContractId);
    //             return getContractProduct(newContractId);
    //             // },300)
    //         })
    //         .then(({ data: productData }) => {
    //             const productId = productData?.[0]?.productId;
    //             if (!productId) throw new Error("No productId in response");
    //             console.log("product id to use for screens = ", productId);
    //             dispatchData(changeWorkQueue({ propertyDropdownTitleId: productId }));
    //             console.log("propertyDropdownTitleId modified to equal productId ", productId);
    //             // setTimeout(() => {
    //             navigate('/Work');
    //             // dispatchData(changeContract({
    //             //     contractDrawerState: false,
    //             //     contractDrawerMode: null,
    //             //     residualsTabsVisible: false,
    //             //     contractGridVisible: true,
    //             //     contractDrilldownVisible: false,
    //             //     contractSearchVisible: false,
    //             //     contractConfigVisible: false,
    //             //     contractView: null,
    //             //     participationsTabsVisible: true,
    //             //     royaltiesTabsVisible: false,
    //             //     cGridRefresh: true,
    //             // }));
    //
    //             dispatchData(changeWork({
    //                 workTabsIndex: 2,
    //                 workQueueMethodTabsIndex: 1,
    //                 searchScreenVisible: false,
    //                 workDashboardVisible: false,
    //                 workContractVisible: true,
    //                 workIssuanceVisible: false,
    //                 expansionDepth: 4
    //             }));
    //             dispatchData(changeContractStats({
    //                 seriesId: null, seriesTitle: null,
    //                 seasonId: null, seasonName: null,
    //                 productId, episodeName: null, photoStartDate: null
    //             }));
    //             dispatchData(changeWorkQueue({
    //                 workQueueCGridAbstractRefresh: true}));
    //
    //             // dispatchData(changeContractStatsControls({
    //             //     gridDisplay: "ProductRightPanel",
    //             //     gridRefresh: true,
    //             // }));
    //             console.log("selectorContractIdGeneratedFromAbstract 2 ", selectorContractIdGeneratedFromAbstract);
    //             dispatchData(changeWorkQueue({
    //                 selectedContractId:  selectorContractIdGeneratedFromAbstract,
    //                 selectedContractDisplayFolders: true}));
    //
    //             // },500)
    //         })
    //         .catch(err => {
    //             console.error("Failed to generate contract:", err);
    //         })
    //         .finally(() => {
    //             setSubmitting(false);
    //             console.log("selectorWorkQueueCContractId before departing from Abstracts = ", selectorWorkQueueCContractId);
    //         });
    // };

    const handleGenerateContractFromAbstract = () => {

        setAnchorEl(null);

        console.log(
            "this abstract will generate the new contract: ",
            selectorContractId2
        );

    getGeneratedAbstractCount(selectorContractId2)
        .then(res => {
            const blockingContracts = Number(res);

            console.log("blocking contracts = ", blockingContracts);

            // Safety check #1
            if (blockingContracts !== 0) {
                console.log(
                    "Contract generation blocked because blockingContracts = ",
                    blockingContracts
                );

                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "error",
                    crudMessage: "Contract Model already exists for this Abstract."
                }));

                return null;
            }

            // Safety check #2
            return getBlockingPartsDeal(selectorContractId2);
        })
        .then(res => {
            // Safety check #1 blocked processing
            if (res === null) return null;

            const blockingPartsDeal = res;

            console.log("blocking parts deal = ", blockingPartsDeal);

            // if (blockingPartsDeal !== null && blockingPartsDeal !== undefined && blockingPartsDeal !== '') {
            //
            //     console.log(
            //         "Contract generation blocked by Parts Deal = ",
            //         blockingPartsDeal
            //     );
            //
            //     dispatchData(changeCrudSnackbar({
            //         crudOpen: true,
            //         crudSeverity: "error",
            //         crudMessage: `The same Deal Type and Contracted Party exist on this Property in this contract: ${blockingPartsDeal}.`
            //     }));
            //
            //     return null;
            // }
            setSubmitting(true);
            // Both safety checks passed
            return generateContractFromAbstract(
                selectorContractId2,
                currentUserId,
                currentUserName,
                currentUserId,
                currentUserDepartment
            );
        })
        .then(res => {
            // Either safety check blocked generation
            if (res == null) return null;
            setSubmitting(false);
            console.log("axios response:", res);

            const data = res.data;
            console.log("data:", data);

            let newContractId;

            if (typeof data === "number") {
                dispatchData(
                    changeContract({
                        contractIdGeneratedFromAbstract: data
                    })
                );

                dispatchData(
                    changeWorkQueue({
                        selectedContractId: data,
                        selectedContractDisplayFolders: true
                    })
                );

                newContractId = data;

            } else if (Array.isArray(data)) {
                newContractId = data[0]?.new_contract_id;

            } else if (data && typeof data === "object") {
                newContractId = data.new_contract_id ?? data.id;
            }

            if (typeof newContractId === "string") {
                const n = Number(newContractId);
                newContractId = Number.isFinite(n) ? n : null;
            }

            if (newContractId == null) {
                console.error(
                    "Unexpected response shape:",
                    data
                );

                throw new Error(
                    "No new_contract_id in response"
                );
            }

            console.log(
                "new contract id:",
                newContractId
            );

            return getContractProduct(newContractId);
        })
        .finally(() => {
            setSubmitting(false);
        })};

    const handleAddGuild = () => {
        setSubmitting(true);
        setAnchorEl(null);
        console.log("this master contract will generate the new guild contract: ", selectorContractId2)   ;
        generateContractFromMasterContract(selectorContractId2,'Guild', currentUserId, currentUserName, currentUserId, currentUserDepartment
        )
            .then((res) => {
                    console.log("axios response:", res);         // full Axios response
                    const data = res.data;                        // unwrap once here
                    console.log("data:", data);                   // should be number or object




                    setSubmitting(false);
                    navigate('/Work');
                    dispatchData(changeWork({workTabsIndex: 2,workQueueMethodTabsIndex: 2,
                        searchScreenVisible: false,
                        workDashboardVisible: false,
                        workContractVisible: true,
                        workIssuanceVisible: false}));
                    dispatchData(changeWorkQueue({
                        unstructuredSearchState: true ,
                        propertySearchState: false,
                        searchScreenVisible: false,
                        bulkEditGridState: false,
                        cardsState: false
                    }));
                    dispatchData(changeContractSearch({
                        id: data,
                        idFrom: null,
                        idTo: null,
                        contractType: null,
                        mcode: null,
                        name: null,
                        createdOn: null,
                        createdFrom: null,
                        createdTo: null,
                        contractSearchGridRefresh: true
                    }));
                    dispatchData(changeWorkQueue({
                        selectedContractId: data}));

                }
            );
    };

    const handleAddOption = () => {
        setSubmitting(true);
        setAnchorEl(null);
        console.log("this master contract will generate the new option contract: ", selectorContractId2)   ;
        generateContractFromMasterContract(selectorContractId2,'Option', currentUserId, currentUserName, currentUserId, currentUserDepartment
        ).then(() => {

                dispatchData(changeContract({
                    contractDrawerState: false,
                    contractDrawerMode: null
                    ,residualsTabsVisible: false
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: true
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: true
                }));
                setSubmitting(false);
                navigate('/Work');
                dispatchData(changeWork({workTabsIndex: 2,workQueueMethodTabsIndex: 2,
                    searchScreenVisible: false,
                    workDashboardVisible: false,
                    workContractVisible: true,
                    workIssuanceVisible: false}));
            }
        );
    };

    const handleAddCast = () => {
        setSubmitting(true);

        setAnchorEl(null);
        console.log("this master contract will generate the new cast contract: ", selectorContractId2)   ;
        generateContractFromMasterContract(selectorContractId2,'Cast', currentUserId, currentUserName, currentUserId, currentUserDepartment
        ).then(() => {

                dispatchData(changeContract({
                    contractDrawerState: false,
                    contractDrawerMode: null
                    ,residualsTabsVisible: false
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: true
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: true
                }));
                setSubmitting(false);
                navigate('/Work');
                dispatchData(changeWork({workTabsIndex: 2,workQueueMethodTabsIndex: 2,
                    searchScreenVisible: false,
                    workDashboardVisible: false,
                    workContractVisible: true,
                    workIssuanceVisible: false}));
            }
        );
    };

    const handleAddEngagement = () => {
        setSubmitting(true);

        setAnchorEl(null);
        console.log("this master contract will generate the new engagement contract: ", selectorContractId2)   ;
        generateContractFromMasterContract(selectorContractId2,'Engagement', currentUserId, currentUserName, currentUserId, currentUserDepartment
        ).then(() => {

                dispatchData(changeContract({
                    contractDrawerState: false,
                    contractDrawerMode: null
                    ,residualsTabsVisible: false
                    ,contractGridVisible: true
                    ,contractDrilldownVisible: false
                    ,contractSearchVisible: false
                    ,contractConfigVisible: false
                    ,contractView: null
                    ,participationsTabsVisible: true
                    ,royaltiesTabsVisible: false
                    ,cGridRefresh: true
                }));
                setSubmitting(false);
                navigate('/Work');
                dispatchData(changeWork({workTabsIndex: 2,workQueueMethodTabsIndex: 2,
                    searchScreenVisible: false,
                    workDashboardVisible: false,
                    workContractVisible: true,
                    workIssuanceVisible: false}));
            }
        );
    };


    // ==== begin delete

    const [confirmOpen, setConfirmOpen] = React.useState(false);

    const handleConfirmClose = () => setConfirmOpen(false);

    const handleDelete = () => {
        setConfirmOpen(true);
        setAnchorEl(null);
    };


    const handleConfirmDelete = () => {
        console.log("contract to be deleted = ", selectorContractId2);
        deleteSingleContract(selectorContractId2)
            .then(() => {
                setConfirmOpen(false);
                dispatchData(changeContract({
                    cGridRefresh: true
                }));
            });
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };


    // ==== end delete


    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem
                onClick={handleEdit}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit Name</ListItemText>
            </MenuItem>

            <MenuItem onClick={handleDelete}>
                <ListItemIcon>
                    <DeleteOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
            </MenuItem>
            <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this record? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <MenuItem onClick={handleMoveUp}>
                <ListItemIcon>
                    <ArrowUpwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Move Up</ListItemText>
            </MenuItem>

            <MenuItem onClick={handleMoveDown}>
                <ListItemIcon>
                    <ArrowDownwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Move Down</ListItemText>
            </MenuItem>

            {selectorContractGridAPI !== "SideletterTemplate" &&
                <MenuItem onClick={handleClone}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Clone</ListItemText>
                </MenuItem>}

            {(selectorContractGridAPI === "PartsStandards" || selectorContractGridAPI === "RoyalStandards") &&
                <MenuItem onClick={handleAbstract}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Abstract</ListItemText>
                </MenuItem>}

            {(selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "RoyalAbstracts") &&
                <MenuItem onClick={handlePartsStandard}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Standard Contract</ListItemText>
                </MenuItem>}


            {(selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "RoyalAbstracts") &&
                <MenuItem
                    onClick={handleGenerateContractFromAbstract}
                >
                    <ListItemIcon>
                        <ArrowForwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Generate Contract Model</ListItemText>
                </MenuItem>}

            {selectorContractGridAPI === "SideletterTemplate" &&
                <MenuItem onClick={handleSideletterFromTemplate}>
                    <ListItemIcon>
                        <NoteAddIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Sideletter</ListItemText>
                </MenuItem>}

            {selectorContractGridAPI === "SideletterTemplate" &&
                <MenuItem onClick={handleClone}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Clone Template</ListItemText>
                </MenuItem>}


            {(selectorContractGridAPI === "CBA" || selectorContractGridAPI === "Sideletter")  &&
                <MenuItem onClick={handleAddGuild}>
                    <ListItemIcon>
                        <AddCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Guild Contract</ListItemText>
                </MenuItem>}

            {(selectorContractGridAPI === "CBA" || selectorContractGridAPI === "Sideletter")  &&
                <MenuItem onClick={handleAddOption}>
                    <ListItemIcon>
                        <AddCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Option Contract</ListItemText>
                </MenuItem>}

            {(selectorContractGridAPI === "CBA" || selectorContractGridAPI === "Sideletter")  &&
                <MenuItem onClick={handleAddCast}>
                    <ListItemIcon>
                        <AddCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Cast Contract</ListItemText>
                </MenuItem>}


            {(selectorContractGridAPI === "CBA" || selectorContractGridAPI === "Sideletter")  &&
                <MenuItem onClick={handleAddEngagement}>
                    <ListItemIcon>
                        <AddCircleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Create Engagement Contract</ListItemText>
                </MenuItem>}

        </Menu>
    );


    return (
        <div
        >
            <Tooltip enterDelay={1000} enterNextDelay={1000} title="Action Menu">
            <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={crudId}
                aria-haspopup="true"
                onClick={handleCrudMenuOpen}

                color="inherit"
            >
                <MoreVertIcon  color="primary" fontSize="small"/>
            </IconButton>
            </Tooltip>
            {renderMenu}
        </div>
    );
}



